import {define, singleton} from '@injex/core';
import EntityRequestAdapter from '../utils/EntityRequestAdapter';
import {IAuthManagerUser} from '../interfaces/IAuthManagerUser';

@define()
@singleton()
export class UsersApi extends EntityRequestAdapter {
    protected basePathName: string = 'users';

    protected get apiEndpoint(): string {
        return this.env.biDashboardsAPI;
    }

    public getUsers({page = 0, q}: {page?: number; q?: string} = {}) {
        const params: {page: number; q?: string} = {page};

        if (q && q.length > 2) {
            params.q = q;
        }

        return this.requestWithContext<IAuthManagerUser[]>({
            method: 'get',
            url: this.makeAPIPath('/'),
            params
        });
    }
}
